import { NavigationGuard } from 'vue-router'

interface HooksType {
  [key: string]: NavigationGuard
}
const hooks: HooksType = {
  getToken: (to, from, next) => {
    next()
  },
  // 解决主页面跳转后子系统pinia数据丢失,重新赋值
  changePiniaState: async (to, from, next) => {
    const nav = to.name
    next()
  },
  test: (to, from, next) => {
    next()
  }
}
export default hooks
